
import { Action } from 'vuex-class';
import { Vue, Component, Watch, Provide } from "vue-property-decorator";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import TravelAreaModalContent from "@/pages/Insure/modals/TravelAreaModalContent.vue";
import InsuredModalContent from "@/pages/Insure/modals/InsuredModalContent.vue";
import { LocationOutput, LocationVO, CustomerInsuredOutput, PeriodValidateInput, PeriodValidateOutput, TravelInformationVO, InsurabilityValidateInput, InsurabilityValidateOutput } from "@fubonlife/tacallindiy-core-axios-sdk"
import InfoModal from "@/plugins/notification/infoModal";

interface ParamFromInsureStep2 {
	travelArea?: string,
	checkedList?: {
		location?: string[],
		insured?: string[]
	},
	startDate?: Date,
	startTime?: string,
	endDate?: Date,
	endTime?: string,
	travelDays?: string
}

@Component({ components: { LayoutLoading, TravelAreaModalContent, InsuredModalContent } })
export default class Insure_step2 extends Vue {
	@Action('setLoading') setLoading;

	// 轉換日期為民國年
	public formatter = this.$twDateFormatter;
	screenWidth: number = 0;
	modalWidth = '80%'
	me = null;

	form = {
		travelArea: "",
		checkedList: {
			location: [],
			insured: []
		},
		startDate: null,
		startTime: null,
		endDate: null,
		endTime: null,
		travelDays: null
	};

	@Provide('cacheInsuredList')
	cacheInsuredList = []

	// 彈窗狀態
	modalOpenStatus = {
		location: false,
		insured: false,
	}

	// 自定義檢核狀態(antd-vue 驗證有4種狀態: error、success、warning、validating)
	validStatus: { [key: string]: string } = {
		travelArea: "",
		location: "",
		insured: "",
		startDate: "",
		startTime: "",
		endDate: "",
		endTime: "",
		travelDays: ""
	};

	// 自定義錯誤訊息
	customErrorMsg: { [key: string]: string } = {
		travelArea: "",
		location: "",
		insured: "",
		startDate: "",
		startTime: "",
		endDate: "",
		endTime: "",
		travelDays: ""
	};

	// 投保開始時間
	timePickerOptions = {
		start: '00:00',
		step: '01:00',
		end: '23:00',
	}

	// 旅遊地區暫存已選選項
	travelAreaTemp = {
		tw: ['000'],
		oversea: [],
		asia: ['100']
	}

	// 國內國外對應代碼 (locationID,locationType)
	locationCode: { [locationName: string]: string[] } = {
		tw: ['098', '1'],
		oversea: ['099', '2'],
		asia: ['100', '3']
	}

	locationData: LocationVO = {}

	insured = []

	async created() {
		this.me = this.$user.getMe();
		if(!this.me){
			// 轉逾時頁面
			this.$router.replace({ path: '/application-timeout' })
			return;
		}
		try{
			this.setLoading(true)
			await this.fetchLocation();
			await this.fetchInsuredList();
			this.setCache();
		}finally{
			this.setLoading(false)
		}
	}

	setCache() {
		const $cacheData = this.$cache.getParam();
		if ($cacheData) {
			// let data = JSON.parse($cacheData)
			this.travelAreaTemp = $cacheData['travelAreaTemp'];
			let form: ParamFromInsureStep2 = $cacheData['form'];
			this.form.travelArea = form.travelArea;
			this.form.checkedList.location.push(...form.checkedList.location);
			this.form.checkedList.insured.push(...form.checkedList.insured);
			this.cacheInsuredList.push(...form.checkedList.insured)
			this.form.startDate = new Date(form.startDate);
			this.form.startTime = form.startTime;
			this.form.travelDays = form.travelDays;
		}
	}

	// 取得畫面寬度
	mounted() {
		this.screenWidth = document.body.clientWidth;
		window.addEventListener('resize',()=>{
			return (() => {
				this.screenWidth = document.body.clientWidth;
			})();
		})
	}

	@Watch("screenWidth")
	modalWidthChange() {
		if (this.screenWidth <= 500) {
			this.modalWidth = "80%";
		} else if (500 < this.screenWidth && this.screenWidth <= 1024) {
			this.modalWidth = "60%";
		} else {
			this.modalWidth = "40%";
		}
	}

	// 取得被保險人資訊
	async fetchInsuredList() {
		await this.$CustomerControllerApi.getCustomerInsuredUsingGET1(this.me.callInNumber)
			.then(res => {
				if (res.status === 200 && res.data.processStatus.status === 'SUCCESS') {
					var custOutput: CustomerInsuredOutput = JSON.parse(JSON.stringify(res.data));
					if (custOutput.processStatus.status === 'SUCCESS') {
						this.insured = custOutput.insuredSorts.map(obj => ({ ...obj, value: obj.insuredID }));
					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: custOutput.processStatus.message,
							customContent: null,
						});
					}
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "被保險人資訊取得失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
	}

	// 取得旅遊地區
	async fetchLocation() {
		if (!sessionStorage.getItem('locationStatus')) {
			await this.$LocationControllerApi.getLocationUsingGET1('0')
				.then(res => {
					if (res.status === 200) {
						var data: LocationOutput = JSON.parse(JSON.stringify(res.data))
						if (data.processStatus.status === 'SUCCESS') {
							this.locationData = data.location;
							var area = this.locationData.locations
							area.forEach(loca => {
								if (!sessionStorage.getItem(loca.locationID)) {
									// add value property
									var newLocations = loca.locations.map(obj => ({ ...obj, value: obj.locationID }))
									sessionStorage.setItem(loca.locationID, JSON.stringify(newLocations));
								}
							})
							sessionStorage.setItem('locationStatus', 'true');
						} else {
							InfoModal.alertModal({
								alertType: "error",
								title: "錯誤",
								content: data.processStatus.message,
								customContent: null,
							});
						}
					}else{
						InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "無法取得旅遊地區資訊，請重新嘗試。",
						customContent: null,
					});
					}
				})
		}
	}

	// 取得國內外對應屬性名稱
	getTravelAreaFieldName(locationId: string) {
		var location = this.locationCode
		switch (locationId) {
			case location.tw[0]: // 國內
				return 'tw'
			case location.oversea[0]: // 國外
				return 'oversea'
			case location.asia[0]: // 亞洲地區
				return 'asia'
		}
	}

	// 取得暫存旅遊地區已選擇選項
	@Watch('form.travelArea')
	setTravelAreaCheckedOptions() {
		this.form.checkedList.location = this.travelAreaTemp[this.getTravelAreaFieldName(this.form.travelArea)];
	}

	// 存取已選地區至暫存 & 觸發檢核
	@Watch('form.checkedList.location')
	setTravelAreaCheckedOptionsTemp() {
		this.travelAreaTemp[this.getTravelAreaFieldName(this.form.travelArea)] = this.form.checkedList.location;
	}

	// 旅遊地區變動時觸發檢核
	@Watch('form.checkedList.location')
	validLocation() {
		this.triggerValidate("location", this.checkRquired(this.form.checkedList.location, '旅遊地區'));
		if (this.form.travelDays) {
			this.checkValidTravelDays(this.form.travelArea, this.form.travelDays);
		}
	}

	// 被保險人變動時觸發檢核
	@Watch('form.checkedList.insured')
	validInsured() {
		this.triggerValidate("insured", this.checkRquired(this.form.checkedList.insured, '被保險人'));
	}

	// 清空開始時間
	@Watch('timePickerOptions.start')
	clearStartTimeOption() {
		let time = this.form.startTime;
		if (time) {
			let hour = parseInt(time.split(':')[0]);
			let minTime = this.timePickerOptions.start;
			let minHour = parseInt(minTime.split(':')[0]);
			if (hour < minHour) {
				this.form.startTime = null;
			}
		}
	}

	// 更新可選時間
	@Watch('form.startDate')
	setStartTimesOptions() {
		this.timePickerOptions.start = this.choosableTime();
	}

	choosableTime() {
		let now = new Date();
		let formDate = this.form.startDate
		if (formDate != null && this.$dateUtils.convertDate2DateStr(formDate) === this.$dateUtils.convertDate2DateStr(now)) {
			now.setHours(now.getHours() + 2);
			console.log(now.getHours().toString().padStart(2, '0') + ':00');
			return now.getHours().toString().padStart(2, '0') + ':00';
		} else {
			return '00:00';
		}
	}

	// 更新結束時間
	@Watch('form.startDate')
	@Watch('form.startTime')
	@Watch('form.travelDays')
	updateEndDateTime() {
		let startDate = this.form.startDate;
		let startTime = this.form.startTime;
		let travelDays = this.form.travelDays;
		if (startDate && startTime && travelDays) {
			this.form.endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + parseInt(travelDays));
			this.form.endTime = startTime;
		} else {
			this.form.endTime = null;
			this.form.endDate = null;
		}
	}

	// 開始日期
	disabledStartDate(current) {
		return current < this.earliestDateForStartDate() || current > this.longestDateForStartDate();
	}

	// 最早可選日期
	earliestDateForStartDate() {
		return new Date().setDate(new Date().getDate() - 1);
	}

	// 最晚可選日期
	longestDateForStartDate() {
		let date = new Date();
		date.setMonth(new Date().getMonth() + 3);
		date.setDate(new Date().getDate() - 1);
		return date;
	}

	// 取得旅遊地區選項內容
	get getTravelAreaOptions() {
		return JSON.parse(sessionStorage.getItem(this.form.travelArea));
	}

	// 國內旅遊 旅遊地區不可選擇
	get getTravelAreaDisable() {
		return !this.form.travelArea || this.form.travelArea === this.locationCode.tw[0] || this.form.travelArea === this.locationCode.asia[0];
	}

	// 同步選擇選項
	selectCheckedList($event: string[], name: string) {
		this.form.checkedList[name] = $event;
		if (name === 'location') {
			this.setTravelAreaCheckedOptionsTemp();
		}
		console.log(name + " checkedList", this.form.checkedList[name])
	}

	// 移除選項
	deselectCheckedList($event: string, name: string) {
		this.removeOption(this.form.checkedList[name], $event);
		if (name === 'insured') {
			let index = this.cacheInsuredList.indexOf($event);
			this.cacheInsuredList.splice(index, 1);
		}
		console.log('deselectCheckedList name', name)
		console.log('deselectCheckedList', this.cacheInsuredList)
	}
	removeOption(arr: string[], option: string) {
		var index = arr.indexOf(option);
		arr.splice(index, 1);
	}

	// 開啟選擇彈窗
	openSelectModal(name: string) {
		this.modalOpenStatus[name] = true;
	}

	// 關閉選擇彈窗
	closeSelectModal($event: string[], name: string) {
		this.selectCheckedList($event, name)
		this.modalOpenStatus[name] = false;
	}

	// 手動觸發 antd FormModel 驗證
	triggerValidate(field: string, msg?: string) {
		if (msg) {
			this.validStatus[field] = "error";
			this.customErrorMsg[field] = msg;
		} else {
			this.validStatus[field] = "success";
			this.customErrorMsg[field] = "";
		}
	}

	// 前端檢核規則-必填
	checkRquired(value: string | string[], requiredName: string) {
		if (!value || value.length === 0) {
			return "請選擇" + requiredName;
		}
	}

	// 前端檢核規則-投保天數
	checkTravelDays(travelArea: string, value: string) {
		if (!value) {
			return "請輸入投保天數";
		}
		if (!/^\+?[1-9]\d*$/.test(value)) {
			this.form.travelDays = null;
			return "請輸入完整投保天數";
		}
		let area = this.getTravelAreaFieldName(travelArea);
		let days = parseInt(value);
		if (area === 'tw' && days > 30 || area === 'oversea' && days > 180 || area === 'asia' && days > 180) {
			return "「台澎金馬」旅遊不得超過30天，國外旅遊不得超過180天。"
		}
	}
	checkValidTravelDays(travelArea: string, value: string) {
		this.triggerValidate("travelDays", this.checkTravelDays(travelArea, value));
		if (this.validStatus.travelDays === "error") {
			return;
		}
	}

	// 取得姓名
	getInsuredName(idNo: string) {
		let index = this.insured.findIndex(e => e['insuredID'] === idNo);
		return this.insured[index]['name'];
	}

	// 送出
	async handleNextStep() {
		const travelAreaHasError = this.checkRquired(this.form.checkedList.location, '旅遊地區');
		const insuredHasError = this.checkRquired(this.form.checkedList.insured, '被保險人');
		const startDateHasError = this.checkRquired(this.form.startDate, '開始日期');
		const startTimeHasError = this.checkRquired(this.form.startTime, '開始時間');
		const travelDaysHasError = this.checkTravelDays(this.form.travelArea, this.form.travelDays);
		if (!travelAreaHasError && !insuredHasError && !startDateHasError && !startTimeHasError && !travelDaysHasError) {
			// 重複投保檢核 & 檢核被保險人投保資格
			const form = this.form;
			const travelArea: LocationVO[] = this.getTravelAreaOptions;
			const locations = travelArea.filter(e => form.checkedList.location.includes(e.locationID));
			const insuredIds = form.checkedList.insured;
			const travelInfo: TravelInformationVO = {
				dateRange: form.travelDays,
				endDate: `${this.$dateUtils.convertDate2DateStr(form.endDate)} ${form.endTime}`,
				startDate: `${this.$dateUtils.convertDate2DateStr(form.startDate)} ${form.startTime}`,
				locations: locations
			}
			console.log("travelInfo", travelInfo)
			const isPeriodValidPass = await this.periodValidate(insuredIds, travelInfo);
			const isInsurabilityValidPass = await this.insurabilityValidate(insuredIds);
			if (!isPeriodValidPass || !isInsurabilityValidPass) {
				return;
			}

			// 送出前緩存
			const $object = {
				form: this.form,
				travelAreaTemp: this.travelAreaTemp
			}
			// 清除緩存
			this.$cache.deleteParamByRouterName(['InsureStep3'])
			this.$cache.setParam($object);
			// 送出
			this.$global.changeRouterAndaddParam({
				toRouter: 'InsureStep3',
				query: {
					insuredIds: insuredIds,
					locationType: this.locationCode[this.getTravelAreaFieldName(form.travelArea)][1],
					travelDays: form.travelDays,
					startDate: `${this.$dateUtils.convertDate2DateStr(form.startDate)} ${form.startTime}`,
					endDate: `${this.$dateUtils.convertDate2DateStr(form.endDate)} ${form.endTime}`
				}
			});
		} else {
			this.triggerValidate("location", travelAreaHasError);
			this.triggerValidate("insured", insuredHasError);
			this.triggerValidate("startDate", startDateHasError);
			this.triggerValidate("startTime", startTimeHasError);
			this.triggerValidate("travelDays", travelDaysHasError);
		}
	}

	async insurabilityValidate(insuredIds: string[]) {
		var insurabilityStatus: boolean = false;
		const me = this.me;
		const input: InsurabilityValidateInput = {
			callInNumber: this.me.callInNumber,
			insuredIDs: insuredIds,
		}
		this.setLoading(true);
		await this.$ValidateControllerApi.insurabilityValidateUsingPOST1(me.token, input)
			.then(res => {
				if (res.status === 200) {
					const result: InsurabilityValidateOutput = JSON.parse(JSON.stringify(res.data))
					if (result.processStatus.status === 'SUCCESS') {
						let ageOver90Result = result.ageOver90;
						if (ageOver90Result.length !== 0) {
							InfoModal.alertModal({
								alertType: "error",
								title: "錯誤",
								content: `${ageOver90Result.map(e=>e.name).join('、')}已超過90歲承保年齡上限，恕不受理本次投保。請重新選擇被保險人。`,
								customContent: null,
							});
						} else {
							insurabilityStatus = true;
						}
					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: result.processStatus.message,
							customContent: null,
						});
					}
				}else{
					InfoModal.alertModal({
					alertType: "error",
					title: "錯誤",
					content: "投保資格檢核失敗，請重新嘗試。",
					customContent: null,
				});
				}
			})
			.finally(()=>{
				this.setLoading(false);
			})
		return insurabilityStatus;
	}

	async periodValidate(insuredIds: string[], travelInfo: TravelInformationVO) {
		var periodStatus: boolean = false;
		const me = this.me;
		const input: PeriodValidateInput = {
			callInNumber: this.me.callInNumber,
			insuredIDs: insuredIds,
			travelInformation: travelInfo
		}
		this.setLoading(true);
		await this.$ValidateControllerApi.periodValidateUsingPOST1(me.token, input)
			.then(res => {
				if (res?.status === 200) {
					const result: PeriodValidateOutput = JSON.parse(JSON.stringify(res.data))
					if (result.processStatus.status === 'SUCCESS') {
						let periodResult = result.periodStatus;
						let periodNotPass = periodResult.filter(e => e.status);
						if (periodNotPass.length !== 0) {
							let msg = [];
							periodNotPass.forEach(e => {
								let insuredName = this.getInsuredName(e.insuredID)
								msg.push(`${insuredName}於${e.originStartDate}~${e.originEndDate}尚有有效保單`)
							})
							msg.push('請調整日期或投保對象')
							InfoModal.alertModal({
								alertType: "error",
								title: "錯誤",
								content: msg,
								customContent: null,
							});
						} else {
							periodStatus = true;
						}
					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: result.processStatus.message,
							customContent: null,
						});
					}
				}else{
					console.log('res.status',res.status)
					InfoModal.alertModal({
					alertType: "error",
					title: "錯誤",
					content: "重複投保檢核失敗，請重新嘗試。",
					customContent: null,
				});
				}
			})
			.finally(()=>{
				this.setLoading(false);
			})
		return periodStatus;
	}
}
